import { render, staticRenderFns } from "./primary-button.vue?vue&type=template&id=b6bd2562&scoped=true"
import script from "./primary-button.vue?vue&type=script&lang=js"
export * from "./primary-button.vue?vue&type=script&lang=js"
import style0 from "./primary-button.vue?vue&type=style&index=0&id=b6bd2562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bd2562",
  null
  
)

export default component.exports